import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** Merges class names, letting a caller's utility override a component default. */
export function cn(...inputs: ClassValue[]): string {
	return twMerge(clsx(inputs));
}
